import { Suspense, lazy } from 'react';
import { MainAppMethods } from '../../App'

const Component = lazy(() => import("./Contact"));

function Contact() {
    return (
        <div>
            <Suspense fallback={<div>loading...</div>}>
              <Component />
            </Suspense>
        </div>);

}

export default Contact; 



